<template>
    <div class="exchange-page">
      <!-- 标题栏 -->
      <div class="header">
        <button class="back-button" @click="goBack">
          <img src="@/assets/arrow-left-s-line.png" alt="返回" class="back-icon" />
        </button>
        <h1>兑换产品: {{ productName }}</h1>
      </div>
  
      <!-- 卡券输入栏 -->
      <div class="card-input">
        <div class="input-row">
          <label for="card-number">礼品卡号: </label>
          <input
            id="card-number"
            v-model="cardSerial"
            type="text"
            placeholder="请输入礼品卡号"
          />
        </div>
        <div class="input-row">
          <label for="card-password">兑换码: </label>
          <input
            id="card-password"
            v-model="cardCode"
            type="text"
            placeholder="请输入兑换码"
          />
        </div>
      </div>
  
      <!-- 收件人信息 -->
      <div class="receiver-info">
        <h2>收件人信息</h2>
        <div class="input-row">
          <label for="receiver-name">收件人: </label>
          <input
            id="receiver-name"
            v-model="receiverName"
            type="text"
            placeholder="请输入收件人名称"
          />
        </div>
        <div class="input-row">
          <label for="receiver-phone">手机号: </label>
          <input
            id="receiver-phone"
            v-model="receiverMobile"
            type="text"
            placeholder="请输入手机号"
          />
        </div>
      </div>
  
      <!-- 收件人地址 -->
      <div class="receiver-address">
        <h2>收件人地址</h2>
        <div class="input-row">
          <label for="province">省: </label>
          <input
            id="province"
            v-model="addrProvince"
            type="text"
            placeholder="请输入省"
          />
        </div>
        <div class="input-row">
          <label for="city">市: </label>
          <input
            id="city"
            v-model="addrCity"
            type="text"
            placeholder="请输入市"
          />
        </div>
        <div class="input-row">
          <label for="district">区/县: </label>
          <input
            id="district"
            v-model="addrArea"
            type="text"
            placeholder="请输入区/县"
          />
        </div>
        <div class="input-row">
          <label for="street">街道/乡镇: </label>
          <input
            id="street"
            v-model="addrStreet"
            type="text"
            placeholder="请输入街道、乡镇"
          />
        </div>
        <div class="input-row-full">
          <label for="address-detail">详细地址: </label>
          <textarea
            id="address-detail"
            v-model="addrDetail"
            placeholder="请输入详细地址"
            rows="3"
          ></textarea>
        </div>
      </div>
  
      <!-- 兑换说明 -->
      <div class="exchange-instructions">
        <h2>兑换说明</h2>
        <div class="instructions-content">
          <ul>
            <li>请确保填写的礼品卡号和兑换码正确无误。</li>
            <li>收件人信息必须真实有效，以便顺利接收商品。</li>
            <li>地址信息需填写完整，确保商品能够准确送达。</li>
            <li>兑换成功后，商品将在3-5个工作日内发货。</li>
            <li>如有疑问，请联系客服：19941356990。</li>
          </ul>
        </div>
      </div>
  
      <!-- 底部确认兑换按钮 -->
      <div class="footer">
        <button class="confirm-button" @click="handleConfirm">确认兑换</button>
      </div>
    </div>
  </template>
  
  <script lang="ts">
import { Options, Vue } from 'vue-class-component';
import axios from 'axios';

@Options({})
export default class ExchangeView extends Vue {
  cardTypeId = '';  // 从路由接收的 cardTypeId
  productId = '';  // 从路由接收的 productId
  productName = ''; // 产品名称

  cardSerial = ''; // 卡号
  cardCode = ''; // 密码

  receiverName = ''; // 收件人名称
  receiverMobile = ''; // 手机号
  addrProvince = ''; // 选择的省
  addrCity = ''; // 选择的市
  addrArea = ''; // 选择的区
  addrStreet = ''; // 选择的街道
  addrDetail = ''; // 地址详情

  apiUrl = process.env.VUE_APP_API_BASE_URL;

  async created() {
    // 从路由 query 中获取 cardTypeId 和 productId
    this.cardTypeId = this.$route.query.cardTypeId as string;
    this.productId = this.$route.query.productId as string;
    this.productName = this.$route.query.productName as string;
  }

  // 返回上一页
  goBack() {
    this.$router.go(-1);
  }

  // 处理确认兑换逻辑
  handleConfirm() {
    if (!this.cardSerial || !this.cardCode) {
      alert('请输入卡号和密码！');
      return;
    }
    if (!this.receiverName || !this.receiverMobile) {
      alert('请输入收件人名称和手机号！');
      return;
    }
    if (!this.addrProvince || !this.addrCity || !this.addrArea || !this.addrStreet || !this.addrDetail) {
      alert('请填写完整的地址信息！');
      return;
    }

    // 提交兑换请求
    this.submitExchange();
  }

  // 提交兑换请求
  async submitExchange() {
    try {
      const response = await axios.post(this.apiUrl + '/gift-card/verify', {
        cardTypeId: this.cardTypeId,
        productId: this.productId,
        cardSerial: this.cardSerial,
        cardCode: this.cardCode,
        receiverName: this.receiverName,
        receiverMobile: this.receiverMobile,
        addrProvince: this.addrProvince,
        addrCity: this.addrCity,
        addrArea: this.addrArea,
        addrStreet: this.addrStreet,
        addrDetail: this.addrDetail,
      });
      if (response.data.code === 0) {
        alert('兑换成功！');
        this.$router.push('/'); // 跳转到首页
      } else {
        alert(`兑换失败: ${response.data.msg}`);
      }
    } catch (error) {
      console.error('Failed to submit exchange:', error);
      alert('兑换失败，请稍后重试！');
    }
  }
}
</script>
  
  <style scoped>
.exchange-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f5f5f5;
}

.header {
  display: flex;
  align-items: center;
  padding: 16px;
  background: linear-gradient(to bottom, #ff3b3b, #ff7e7e); /* 红色渐变色 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  text-align: center;
}

.back-button {
  background: none;
  border: none;
  font-size: 24px;
  color: white; /* 返回按钮颜色改为白色 */
  cursor: pointer;
  position: absolute;
  left: 16px;
}

.back-icon {
  width: 24px;
  height: 24px;
}

.header h1 {
  font-size: 18px;
  color: white; /* 标题颜色改为白色 */
  margin: 0 auto;
}

/* 卡券输入栏 */
.card-input {
  padding: 16px;
  background-color: #ffffff;
  margin-bottom: 16px;
}

/* 收件人信息 */
.receiver-info {
  padding: 16px;
  background-color: #ffffff;
  margin-bottom: 16px;
}

/* 收件人地址 */
.receiver-address {
  padding: 16px;
  background-color: #ffffff;
}

/* 兑换说明 */
.exchange-instructions {
  padding: 16px;
  padding-bottom: 100px;
  background-color: #ffffff;
  margin-bottom: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: left;
}

.exchange-instructions h2 {
  font-size: 16px;
  color: #333;
  margin-bottom: 16px;
  text-align: center;
}

.instructions-content {
  padding: 16px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.instructions-content ul {
  list-style-type: disc;
  padding-left: 20px;
  margin: 0;
}

.instructions-content li {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.input-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.input-row label {
  flex: 0 0 80px; /* 固定标签宽度 */
  font-size: 14px;
  color: #333;
  font-weight: bold;
}

.input-row input {
  flex: 1;
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* 详细地址输入框与标签在同一行 */
.input-row-full {
  display: flex;
  align-items: flex-start; /* 顶部对齐 */
  margin-bottom: 16px;
}

.input-row-full label {
  flex: 0 0 80px; /* 固定标签宽度 */
  font-size: 14px;
  color: #333;
  font-weight: bold;
  margin-top: 8px; /* 与 textarea 顶部对齐 */
}

.input-row-full textarea {
  flex: 1;
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical; /* 允许垂直调整大小 */
  min-height: 80px; /* 设置最小高度 */
}

/* 底部按钮 */
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background-color: #ffffff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.confirm-button {
  width: 100%;
  padding: 12px;
  background-color: #ff7e7e;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.confirm-button:hover {
  background-color: #ff5a5a;
}
</style>